var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visible - Off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.775736 0.775834C1.01005 0.541519 1.38995 0.541519 1.62426 0.775834L11.2243 10.3758C11.4586 10.6101 11.4586 10.99 11.2243 11.2244C10.99 11.4587 10.6101 11.4587 10.3757 11.2244L8.54071 9.38933C7.76365 9.72481 6.90402 9.91119 5.99948 9.91119C3.33015 9.91119 1.05192 8.28808 0.132812 6.00008C0.585929 4.87211 1.36937 3.90573 2.36714 3.21577L0.775736 1.62436C0.541421 1.39005 0.541421 1.01015 0.775736 0.775834ZM3.89979 4.74842C3.67604 5.12379 3.55503 5.5557 3.55503 6.00008C3.55503 6.64838 3.81257 7.27014 4.271 7.72856C4.72942 8.18698 5.35117 8.44452 5.99948 8.44452C6.44386 8.44452 6.87576 8.32352 7.25114 8.09976L6.52253 7.37115C6.36015 7.43293 6.18385 7.46674 5.99948 7.46674C5.18792 7.46674 4.53281 6.81163 4.53281 6.00008C4.53281 5.8157 4.56663 5.6394 4.6284 5.47703L3.89979 4.74842Z",
    fill: "#7E86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09347 3.55744L4.74679 2.21076C5.15157 2.13089 5.57047 2.08896 5.99948 2.08896C8.66881 2.08896 10.947 3.71208 11.8661 6.00008C11.5631 6.75455 11.1122 7.43672 10.5483 8.01224L8.44212 5.90609C8.41851 5.29193 8.16418 4.70781 7.72796 4.27159C7.29174 3.83537 6.70762 3.58105 6.09347 3.55744Z",
    fill: "#7E86A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleOff);
export default __webpack_public_path__ + "static/media/visible-off.b048d32b551ed5651544d0fd4e3b83b3.svg";
export { ForwardRef as ReactComponent };